import React from 'react';
import LoadingIcon from '../../../assets/img/loading.svg';

export default function BCLLoading(){
  return(
    <div className="loading-screen">
      <img src={LoadingIcon} alt="Loading" />
    </div>
  )
}
